import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';

export interface SliderUniDriver extends BaseUniDriver {
  isDotSelected: (value: number) => Promise<boolean>;
  numOfSliderDots: () => Promise<number>;
  numOfSliderHandles: () => Promise<number>;
  numOfSliderMarksLabels: () => Promise<number>;
  getToolTipValue: (index: number) => Promise<string>;
  isDisabled: () => Promise<boolean>;
  getDirection: () => Promise<'vertical' | 'horizontal'>;
}
